// extracted by mini-css-extract-plugin
export default {"staticWidget":"styles_staticWidget__jO21G","quicksightFrame":"styles_quicksightFrame__MOzTQ","quicksightFramePlaceHolder":"styles_quicksightFramePlaceHolder__eX-Fh"};